import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Import Components
import { CJInfoBlockLabelValueWrapper } from 'components/CustomerJourney/infoBlocks';
// Import Services
import Helpers from 'services/Helpers';
// Import Hooks
import { usePartnerDateFormats } from 'hooks/UsePartnerDateFormats';
// Import Constants
import { ExpirationBonusModelTypes, ExpirationTypes, l } from 'constants/common';

const { customMomentWithoutTimezoneConversion } = Helpers;

const Expiration = {
    [ExpirationBonusModelTypes[ExpirationTypes.ExpirationDate]]: {
        typeName: l.ToGivenDate,
        name: l.Date,
        key: 'Date',
    },
    [ExpirationBonusModelTypes[ExpirationTypes.ExpirationPeriod]]: {
        typeName: l.FromPayoutDate,
        name: l.Day,
        key: 'Period',
    },
};

const CJBonusExpirationInfo = ({ expiration }) => {
    const { t } = useTranslation();
    const { partnerDateFormat } = usePartnerDateFormats();

    const calculatedExpirationValue = useMemo(() => {
        const tempValue = expiration[Expiration[expiration.$type].key];

        switch (expiration.$type) {
            case ExpirationBonusModelTypes.expirationDate: {
                return customMomentWithoutTimezoneConversion(tempValue).format(partnerDateFormat);
            }
            case ExpirationBonusModelTypes.expirationPeriod: {
                return tempValue.split('.')[0];
            }
            default:
                return t(l.NA);
        }
    }, [expiration, partnerDateFormat, t]);

    return (
        <>
            <CJInfoBlockLabelValueWrapper
                label={t(l.ExpirationType)}
                value={t(Expiration[expiration.$type].typeName)}
            />
            <CJInfoBlockLabelValueWrapper
                label={t(Expiration[expiration.$type].name)}
                value={calculatedExpirationValue}
            />
        </>
    );
};

CJBonusExpirationInfo.propTypes = {
    expiration: PropTypes.object.isRequired,
};

export default memo(CJBonusExpirationInfo);
